var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-alert',{attrs:{"value":_vm.show,"color":"error","icon":"report","outline":""}},[_vm._v("\n    Facility is inactive, contact admin broker\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }